module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/leave-details/leave-details-grid/leave-details-grid.component.css
// module id = ./src/app/hrms/serviceregister/leave-details/leave-details-grid/leave-details-grid.component.css
// module chunks = main